export default __webpack_public_path__ + "static/media/Cycling.937b1760.png";